module.exports = __webpack_public_path__ + "static/img/icon_tel_blue@3x.881fbb30.png";